import { useTranslation } from 'react-i18next'
import { HUBPLATFORM_START_URL } from '../../services/api'
import { HUBPLATFORM_RESULT } from '../../services/hubplatformLanding'

/**
 * VH-317 — "Sign in with HubPlatform" below the own login, full width on a
 * phone (platform standard §1.5). A plain link: the browser goes to
 * HubPlatform and comes back to /login. `note` is what the last try said.
 */
export default function HubPlatformButton({ note = null }) {
  const { t } = useTranslation()
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3 text-xs uppercase text-gray-400" aria-hidden="true">
        <span className="h-px flex-1 bg-gray-200" />
        {t('hubplatform.or')}
        <span className="h-px flex-1 bg-gray-200" />
      </div>
      <a href={HUBPLATFORM_START_URL} className="btn-secondary flex w-full justify-center py-3 text-base">
        {t('hubplatform.signIn')}
      </a>
      {note && (
        <p role="alert" className="rounded bg-red-50 px-3 py-2 text-center text-sm text-red-800">
          {t(note === HUBPLATFORM_RESULT.UNREACHABLE ? 'hubplatform.unreachable' : 'hubplatform.refused')}
        </p>
      )}
    </div>
  )
}
